import * as sidebarmenu from './sidebarmenu.json';
import * as lang from './lang.json';

const allEn = {
  lang,
  sidebarmenu,
};

export default allEn;
